import { Button, Input, toast } from "@/components/kit";
import {
  FieldContent,
  FieldLabel,
  Field as FieldLayout,
} from "@/components/ui/field";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import {
  useImportOrderExchangeSettings,
  useUpdateImportOrderExchangeSettings,
} from "@/modules/inventory/presentation/api/import-orders-queries";
import { DEFAULT_IMPORT_EXCHANGE_RATE } from "@/modules/inventory/domain/import-order-settings";
import { useEffect, useState } from "react";

export function ImportOrderSettingsSection() {
  const canManage = useActionPermission("import_orders:write");
  const query = useImportOrderExchangeSettings();
  const update = useUpdateImportOrderExchangeSettings();
  const [defaultRateInput, setDefaultRateInput] = useState(
    String(DEFAULT_IMPORT_EXCHANGE_RATE),
  );

  useEffect(() => {
    if (!query.data) return;
    setDefaultRateInput(String(query.data.defaultExchangeRate));
  }, [query.data]);

  function handleSave() {
    const defaultExchangeRate = Number.parseFloat(defaultRateInput);
    if (!Number.isFinite(defaultExchangeRate) || defaultExchangeRate <= 0) {
      toast.error("ອັດຕາແລກປ່ຽນຕ້ອງເປັນຕົວເລກທີ່ມີຄ່າ");
      return;
    }

    update.mutate(
      { defaultExchangeRate },
      {
        onSuccess: () => toast.success("ບັນທຶກການຕັ້ງຄ່າສັ່ງນຳເຂົ້າແລ້ວ"),
        onError: (e) =>
          toast.error("ບັນທຶກບໍ່ສຳເລັດ", {
            description: e instanceof Error ? e.message : undefined,
          }),
      },
    );
  }

  if (query.isLoading) {
    return <p className="text-muted-foreground text-sm">ກຳລັງໂຫຼດ...</p>;
  }

  return (
    <div className="flex max-w-2xl flex-col gap-6">
      <div>
        <h3 className="font-display text-lg">ສັ່ງນຳເຂົ້າ</h3>
        <p className="text-muted-foreground text-sm">
          ຄ່າເລີ່ມຕົ້ນສຳລັບຟອມ import order — ລະບົບຈື່ອັດຕາລ່າສຸດອັດຕະໂນມັດຫຼັງບັນທຶກ
        </p>
      </div>

      <FieldLayout>
        <FieldLabel>ອັດຕາແລກປ່ຽນເລີ່ມຕົ້ນ (LAK / CNY)</FieldLabel>
        <FieldContent>
          <Input
            type="number"
            min={1}
            step="0.01"
            value={defaultRateInput}
            onChange={(e) => setDefaultRateInput(e.target.value)}
            disabled={!canManage}
          />
        </FieldContent>
      </FieldLayout>

      {query.data?.lastExchangeRate ? (
        <p className="text-muted-foreground text-sm">
          ຄ່າລ່າສຸດທີ່ໃຊ້:{" "}
          <span className="font-medium text-foreground tabular-nums">
            {query.data.lastExchangeRate.toLocaleString("lo-LA")}
          </span>
        </p>
      ) : null}

      {canManage ? (
        <Button
          className="rounded-full"
          isLoading={update.isPending}
          onClick={handleSave}
        >
          ບັນທຶກການຕັ້ງຄ່ານຳເຂົ້າ
        </Button>
      ) : null}
    </div>
  );
}
